export const RESET = 'EXCMAGREEMENTDEVICE_UPDATE_RESET'
export const SET_ERROR = 'EXCMAGREEMENTDEVICE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMAGREEMENTDEVICE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMAGREEMENTDEVICE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMAGREEMENTDEVICE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMAGREEMENTDEVICE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMAGREEMENTDEVICE_UPDATE_UPDATE_RETRIEVED'
